import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './css/style.css';
import './css/animate.css';
import './css/flaticon.css';
import './css/font-awesome.css';
import './css/nouislider.css';
import './css/owl.css';
import './css/responsive.css';
import './css/revolution-slider.css';
import './css/slider.css';
import './css/contact-info.css';
import './css/slider.css';
import './css/slider.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
